export default __webpack_public_path__ + "static/media/default_teacher.9a9b0fa2.jpg";